export const FaColumnsIcon = (props) => (
  <svg aria-hidden="true" fill="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM64 96l0 320 96 0 0-320L64 96zM224 416l64 0 0-320-64 0 0 320zm128 0l96 0 0-320-96 0 0 320z" />
  </svg>
);
